import * as actionTypes from './actionTypes';
import admSvc from '../../axios-admsvc';

export const fetchStates = () => {
    return dispatch => {
        admSvc.get('/states')
            .then(response => {
                // console.log("[Reference Data] Fetch States Response: ", response.data);
                dispatch(fetchStatesSuccess(response.data));
            })
            .catch(error => {
            // console.log("[Reference Data] Fetch States Error: ", error);
            dispatch(fetchStatesFailure(error));
            // this.setState({error: {message:"Oops!! Something didn't work. Pls try again."}});
            // return Promise.reject(error.response);
            return error.response;
        });
    }
}

export const fetchStatesSuccess = (states) => {
    return {
        type: actionTypes.FETCH_STATES_SUCCESS,
        states: states
    }
}

export const fetchStatesFailure = (error) => {
    return {
        type: actionTypes.FETCH_STATES_SUCCESS,
        error: error
    }
}
